<template lang="pug">
    v-container(grid-list-md v-if="content" )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="content.info.instanceName" label="Penyedia Jasa" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="customerId" label="No. Virtual Account" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg12 md12 xs12 v-if="content.type == 'INVOICE'")
                v-expansion-panels(dense)
                    v-expansion-panel(v-for="items in content.bills" :key="items.billNumber")
                        v-expansion-panel-header(class="subtitle-text") {{items.billNumber}}
                        v-expansion-panel-content
                            v-layout(wrap)
                                v-flex(lg8 md8 xs12 class="caption")
                                    v-layout(wrap)
                                        v-flex(lg3 md3 xs3)
                                            v-btn(dense fab small color="primary" @click="selectInvoice(items)")
                                                v-icon mdi-check-all
                                        v-flex(lg9 md9 xs9)
                                            div {{items.billName}}
                                v-flex(lg4 md4 xs12 class="caption font-weight-bold align-self-center justify-end text-right") Rp. {{items.amount | decimalformat}}
            v-flex(lg12 md12 xs12 v-if="content.type == 'INSTALLMENT'")
                v-expansion-panels(dense)
                    v-expansion-panel(v-for="items in content.bills" :key="items.billNumber")
                        v-expansion-panel-header(class="subtitle-text") {{items.billNumber}}
                        v-expansion-panel-content
                            v-layout(wrap)
                                v-layout(wrap v-if="items.otherInfo.installmentType == 'CLOSED'")
                                    v-flex(lg12 md12 xs12 class="caption font-weight-bold justify-end text-right")
                                        v-layout(wrap)
                                            v-flex(lg6 md6 xs12)
                                                div Tenor : {{items.otherInfo.tenor > 0 ? items.otherInfo.tenor : '-'}}
                                                div Sisa Tenor : {{items.otherInfo.deficiencyTenor > 0 ? items.otherInfo.deficiencyTenor : '-'}}
                                            v-flex(lg6 md6 xs12)
                                                div Jumlah : Rp. {{items.otherInfo.installmentAmount | decimalformat}}
                                                div Sisa : Rp. {{items.otherInfo.deficiencyAmount | decimalformat}}
                                        v-divider
                                    v-flex(lg8 md8 xs12 class="caption")
                                        v-layout(wrap v-if="items.otherInfo.detail.length > 0")
                                            v-flex(lg3 md3 xs3)
                                                v-btn(dense fab small color="primary" @click="selectInstallment(items, items.otherInfo.detail[0])")
                                                    v-icon mdi-check-all
                                            v-flex(lg9 md9 xs9 class="align-self-center")
                                                div() {{items.billName}}
                                                div() Batas Akhir Pembayaran {{items.billDate | dateformat}}
                                    v-flex(lg4 md4 xs12 class="caption font-weight-bold align-self-center justify-end text-right" ) Rp. {{items.otherInfo.detail[0].amount | decimalformat}}
                                v-layout(wrap v-else)
                                    v-flex(lg12 md12 xs12 class="caption font-weight-bold justify-end text-right")
                                        v-layout(wrap)
                                            v-flex(lg2 md2 xs12)
                                                div Tenor : {{items.otherInfo.tenor > 0 ? items.otherInfo.tenor : '-'}}
                                                div Sisa Tenor : {{items.otherInfo.deficiencyTenor > 0 ? items.otherInfo.deficiencyTenor : '-'}}
                                            v-flex(lg5 md5 xs12)
                                                div Min Transaksi : Rp. {{items.otherInfo.minTransaction | decimalformat}}
                                                div Max Transaksi : Rp. {{items.otherInfo.maxTransaction | decimalformat}}
                                            v-flex(lg5 md5 xs12)
                                                div Jumlah : Rp. {{items.otherInfo.installmentAmount | decimalformat}}
                                                div Sisa : Rp. {{items.otherInfo.deficiencyAmount | decimalformat}}
                                        v-divider
                                    v-flex(lg8 md8 xs12 class="caption")
                                        v-layout(wrap)
                                            v-flex(lg3 md3 xs3)
                                                v-btn(dense fab small color="primary" @click="setBillInstallment(items)")
                                                    v-icon mdi-check-all
                                            v-flex(lg9 md9 xs9 class="align-self-center")
                                                div() {{items.billName}}
                                                div() Batas Akhir Pembayaran {{items.billDate | dateformat}}
                                    v-flex(lg4 md4 xs12 class="caption font-weight-bold align-self-center justify-end text-right") 
                                        f-decimalbox(v-model="billAmount" label="Nominal" :rules="[v => !!v || 'Masukan nominal transaksi', v => (billAmount || 0) > 0 || 'Nominal tidak valid' ]" :required="true")
            v-flex(lg12 md12 xs12 v-if="content.type == 'DEFAULT'")
                v-flex(lg12 md12 xs12 class="caption font-weight-bold justify-center text-center")
                    v-layout(wrap v-if="!readonlyDefault")
                        v-flex(lg6 md6 xs12) Min Transaksi : {{content.info.minTransaction >= 0 ? ('Rp. ' + content.info.minTransaction) : '-'}}
                        v-flex(lg6 md6 xs12) Max Transaksi : {{content.info.maxTransaction > 0 ? ('Rp. ' + content.info.maxTransaction) : '-'}}
                v-flex(lg4 md4 xs12)
                    v-form(ref="form" id="form" @submit.prevent="setBill" lazy-validation)
                        f-decimalbox(v-model="billAmount" label="Nominal" :rules="[v => !!v || 'Masukan nominal transaksi', v => (billAmount || 0) > 0 || 'Nominal tidak valid' ]" :required="true" :readonly="readonlyDefault" :template="true")
        div(justify-center style="text-align: center" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doBack") Kembali
                v-icon mdi-arrow-left
            v-btn(v-if="content.type == 'DEFAULT'" color="btnprimary white--text" class="mx-1" @click="setBill(billAmount)") Lanjutkan
                v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FMultiPaymentContent",
    props: ["content"],
    data() {
        return {
            billAmount: null,
            readonlyDefault: false,
            productDescription: "MULTI PAYMENT"
        }
    },
    watch: {
        content(val){
            this.resetBill();
        }
    },
    mounted() {
        this.resetBill();
    },
    computed: {
        source() {
            return this.$options.filters.accountformat(this.content.source) + " - " + this.content.sourceName;
        },
        customerId() {
            return this.content.parameters.virtualAccountNumber + " - " + this.content.info.customerName;
        }
    },
    methods: {
        resetBill(){
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            this.billAmount = null;
            this.readonlyDefault = false;
            if (this.content && this.content.type == "DEFAULT"){
                this.validateReadOnlyDefault();
            }
        },
        selectInvoice(bill) {
            let bills = {
                merchantId: this.content.info.instanceId,
                virtualAccount: this.content.parameters.virtualAccountNumber,
                invoiceId: bill.billNumber,
                invoiceMessage: bill.billName,
                note: bill.billName,
                amount: bill.amount,
                type: this.content.type,
                virtualAccountName: this.content.info.customerName
            }
            this.$emit("bill", bills);
        },
        selectInstallment(bill, detail) {
            let bills = {
                merchantId: this.content.info.instanceId,
                virtualAccount: this.content.parameters.virtualAccountNumber,
                installmentId: bill.billNumber,
                installmentMessage: bill.billName,
                note: bill.billName,
                installmentDetailId: detail.installmentDetailId,
                amount: detail.amount,
                type: this.content.type,
                virtualAccountName: this.content.info.customerName
            }
            this.$emit("bill", bills);
        },
        setBillInstallment(bill) {
            if(this.billAmount > 0){
                let bills = {
                    merchantId: this.content.info.instanceId,
                    virtualAccount: this.content.parameters.virtualAccountNumber,
                    installmentId: bill.billNumber,
                    installmentMessage: bill.billName,
                    note: bill.billName,
                    amount: this.billAmount,
                    type: this.content.type,
                    virtualAccountName: this.content.info.customerName
                }
                this.$emit("bill", bills);
            }
        },
        setBill(bill) {
            if(this.$refs.form.validate()){
                let bills = {
                    merchantId: this.content.info.instanceId,
                    virtualAccount: this.content.parameters.virtualAccountNumber,
                    amount: this.billAmount,
                    type: this.content.type,
                    virtualAccountName: this.content.info.customerName
                }
                this.$emit("bill", bills);
            }
        },

        validateReadOnlyDefault(){
            this.billAmount = this.content.amount || 0;
            if (this.billAmount > 0){
                this.readonlyDefault = true;
            }
        },
        doBack(){
            this.$emit("back");
        },
    },
};
</script>